<template>
  <div class="gyroAccess is-flex is-flex-direction-column">
    <slot :DeviceOrientationEnabled="DeviceOrientationEnabled" :dataStarted="dataStarted" :callibrated="callibrated"
      :alpha="orientation.alpha" :beta="orientation.beta" :gamma="orientation.gamma" :x="coords.x" :y="coords.y" :acceleration="acceleration" :noGyro="noGyro">
    </slot>
  </div>
</template>

<script>
const utils = require("./utils");

export default {
  data() {
    return {
      callibrated: false,
      DeviceOrientationEnabled: false,
      dataStarted: false,
      noGyro: true,
      orientation: {},
      acceleration: {},
      offsetAlpha: 0,
      offsetBeta: 0,
      offsetGamma: 0
    }
  },
  props: {
    range: {
      type: Number,
      required: false,
      default: 20, // Range of deegress to map into 0~1
    },
  },
  methods: {
    // ShowPreRequestDialog(){
    //   this.$buefy.dialog.alert({
    //       message: 'To use this experience we need to ask your permission to use the gyroscope',
    //       confirmText: 'I accept',
    //       type: 'is-success',
    //       onConfirm: () => this.RequestGyro()
    //   })
    // },
    // DeviceOrientationEvent es el gyro
    // https://developer.mozilla.org/en-US/docs/Web/API/DeviceOrientationEvent
    // Provee un evento que devuelve alpha, beta y gamma
    RequestGyro() {
      console.log("RequestGyro access");
      if (this.DeviceOrientationsNeedsRequest()) {
        console.log("requesting permission");
        DeviceOrientationEvent.requestPermission()
          .then(permissionState => {
            if (permissionState === 'granted') {
              // window.addEventListener('deviceorientation', (e) => { this.HandleGyroData(e) })
              window.addEventListener('deviceorientation', this.HandleOrientationData)
              window.addEventListener('devicemotion', this.HandleMotionData, true)
            } else {
              // Permission denied
            }
          })
          .catch(console.error);
      } else {
        console.log("permission not necessary");
        // handle regular non iOS 13+ devices
        // window.addEventListener('deviceorientation', (e) => { this.HandleGyroData(e) });
        window.addEventListener('deviceorientation', this.HandleOrientationData)
        window.addEventListener('devicemotion', this.HandleMotionData, true)
      }
    },
    HandleOrientationData(evt) {
      this.dataStarted = true;
      // solo 3 decimales
      this.orientation = {
        alpha: Math.round(evt.alpha),
        beta: Math.round(evt.beta),
        gamma: Math.round(evt.gamma)
      }

    },
    HandleMotionData(evt) {
      console.log("acceleration", evt)
      this.dataStarted = true;
      this.acceleration = {
        x: evt.x,
        y: evt.y,
        z: evt.z
      }
    },
    Callibrate() {
      console.log("Callibrated")
      this.offsetAlpha = this.orientation.alpha;
      this.offsetBeta = this.orientation.beta;
      this.offsetGamma = this.orientation.gama;

      this.callibrated = true;
      this.$emit('callibrated')
    },
    DeviceOrientationsNeedsRequest() {
      return typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function'
    },
  },
  computed: {
    coords() {
      
      let x = this.orientation.alpha - this.offsetAlpha;
      let y = this.orientation.beta - this.offsetBeta;

      if (x > 180)  x = x - 360

      x += this.range;
      x /= this.range * 2;
      x = 1 - utils.clamp(x, 0, 1);
      y = utils.map(y, -this.range, this.range, 1, 0)

      // 3 numeros decimales.
      x = Math.round(x * 1e3) / 1e3;
      y = Math.round(y * 1e3) / 1e3;
      return { x, y }
    }
  },
  watch: {
    coords() {
      // console.log("coords changed")
      // if (!this.callibrated) return;
      // TODO cooldown
      // Emits a custom event *moved* to parent component
      this.$emit('moved', {
        coords: this.coords,
        orientation: this.orientation,
        acceleration: this.acceleration
      })
    },
    dataStarted() {
      this.noGyro = !this.DeviceOrientationEnabled && !this.dataStarted
    },
    DeviceOrientationEnabled() {
      this.Network = !this.DeviceOrientationEnabled && !this.dataStarted
    }
  },
  mounted() {
    // if (this.DeviceOrientationsNeedsRequest()) {
    // this.ShowPreRequestDialog()
    // }
  },
  beforeDestroy() {
    // remove listener
    window.removeEventListener("deviceorientation", this.HandleOrientationData)
    window.removeEventListener("devicemotion", this.HandleMotionData)
  }
};
</script>